module.exports = __webpack_public_path__ + "img/note_light_icon.47f06b22.svg";